import type { JSX } from "react";
import { useFormContext } from "react-hook-form";

import { useModuleContext } from "@/hooks/useModuleContext";
import { PropertyInformation } from "@/types/refineRealEstate";

import { ImagesGallery } from "./ImagesGallery";
import { ImagesList } from "./ImagesList";

interface ImageTabProps {
  useImagesList?: boolean;
  readonly?: boolean;
  valuationId?: string | null;
  pendingImages?: Array<{
    id: string;
    file: File;
    preview: string;
    title: string;
  }>;
  setPendingImages?: React.Dispatch<
    React.SetStateAction<
      Array<{
        id: string;
        file: File;
        preview: string;
        title: string;
      }>
    >
  >;
}

export const ImagesTab = ({
  readonly,
  valuationId,
  pendingImages,
  setPendingImages,
  useImagesList = false,
}: ImageTabProps): JSX.Element => {
  const { watch } = useFormContext<PropertyInformation>();

  const { isValuationReport } = useModuleContext();

  const { propertyImages } = watch();
  if (isValuationReport || useImagesList) {
    return <ImagesList showWidgetEmptyState={useImagesList} />;
  }

  return (
    <ImagesGallery
      images={propertyImages.images || []}
      valuationId={valuationId}
      pendingImages={pendingImages}
      setPendingImages={setPendingImages}
      readonly={readonly}
    />
  );
};
